module.exports = __webpack_public_path__ + "media/icons/rok-produkcji@2x-33c14ec9.png";